import React from "react";

import { tw } from "~/utils";

// Create a button component that can be reused in other components with props bg color and text color and props to display icon
interface KonnectButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  text?: string;
  bgColor?:
    | "purple"
    | "transparent"
    | "charcoal"
    | "white"
    | "teal"
    | "gray-200";
  textColor?: "white" | "charcoal" | "purple" | "teal";
  hoverBgColor?:
    | "purple/80"
    | "transparent"
    | "charcoal/80"
    | "white"
    | "teal/80"
    | "charcoal";
  hoverTextColor?: "white" | "charcoal" | "purple" | "gray-200";
  children?: React.ReactNode;
  icon?: boolean | React.ReactNode;
  className?: string;
}

const KonnectButton = ({
  bgColor = "purple",
  textColor = "white",
  hoverTextColor = "white",
  hoverBgColor = "purple/80",
  text,
  icon,
  className,
  children,
  ...rest
}: KonnectButtonProps) => (
  <button
    className={tw(
      ` hover:text-${hoverTextColor} flex items-center justify-center rounded-full px-[16px] py-[12px] text-center font-medium transition hover:bg-${
        hoverBgColor || bgColor
      } bg-${bgColor} text-${textColor} disabled:cursor-not-allowed`,
      className
    )}
    {...rest}
  >
    {icon && typeof icon == "boolean" && (
      <svg
        width="7"
        height="12"
        viewBox="0 0 7 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1L5.89956 5.76444C5.9314 5.79536 5.95666 5.83208 5.9739 5.8725C5.99113 5.91292 6 5.95624 6 6C6 6.04376 5.99113 6.08708 5.9739 6.1275C5.95666 6.16792 5.9314 6.20464 5.89956 6.23556L1 11"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}

    {icon && React.isValidElement(icon) && icon}

    {text && <span className={`${icon ? "ml-[10px]" : ""}`}>{text}</span>}
    {children}
  </button>
);

export default KonnectButton;
